export { default as FilterListSolidIcon } from './FilterListSolidIcon';
